// Generated types for PDMRequirement
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { Priority, RequirementStatus, RequirementType } from '../../shared/enums';

import { RequirementDefinitionReadAPI, RequirementDefinitionWriteAPI } from '../../sysml/types/requirementdefinition';
import { RequirementDefinitionReadAPISchemaObject, RequirementDefinitionWriteAPISchemaObject } from '../../sysml/types/requirementdefinition';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PDMRequirementReadAPI extends RequirementDefinitionReadAPI {
  /** Requirement type classification */
  type?: RequirementType;
  /** Priority level */
  priority?: Priority;
  /** The current status of the requirement. Each possible status is explained below:
            - "OK": the requirement is fine
            - "TBA": the requirement is to be anlayzed.
            - "ERROR": a requirement with a value that is clearly incoherent, logically impossible.
            - "WARNING": a requirement whose value appears unusual or questionable, but not impossible.
         */
  status?: RequirementStatus | null;
  /** Information about why the attribute is needed or the reasoning and assumptions behind the suggested values */
  analysis?: string | null;
  /** list of informative suggested possible values for the attribute */
  suggestions?: string[] | null;
}

export interface PDMRequirementWriteAPI extends RequirementDefinitionWriteAPI {
  /** Requirement type classification */
  type?: RequirementType;
  /** Priority level */
  priority?: Priority;
  /** The current status of the requirement. Each possible status is explained below:
            - "OK": the requirement is fine
            - "TBA": the requirement is to be anlayzed.
            - "ERROR": a requirement with a value that is clearly incoherent, logically impossible.
            - "WARNING": a requirement whose value appears unusual or questionable, but not impossible.
         */
  status?: RequirementStatus | null;
  /** Information about why the attribute is needed or the reasoning and assumptions behind the suggested values */
  analysis?: string | null;
  /** list of informative suggested possible values for the attribute */
  suggestions?: string[] | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PDMRequirementReadAPISchema: z.ZodType<PDMRequirementReadAPI> = RequirementDefinitionReadAPISchemaObject.extend({
  type: z.nativeEnum(RequirementType).optional(),
  priority: z.nativeEnum(Priority).optional(),
  status: z.nativeEnum(RequirementStatus).nullable().optional(),
  analysis: z.string().nullable().optional(),
  suggestions: z.array(z.string()).nullable().optional(),
}).passthrough();

export const PDMRequirementWriteAPISchema: z.ZodType<PDMRequirementWriteAPI> = RequirementDefinitionWriteAPISchemaObject.extend({
  type: z.nativeEnum(RequirementType).optional(),
  priority: z.nativeEnum(Priority).optional(),
  status: z.nativeEnum(RequirementStatus).nullable().optional(),
  analysis: z.string().nullable().optional(),
  suggestions: z.array(z.string()).nullable().optional(),
}).passthrough();
